import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Form, Button } from "react-bootstrap";
import FileDownload from "js-file-download";
import { Buffer } from "buffer"

import { CreateSignP7S } from "../../routes/cryptography";

import "bootstrap/dist/css/bootstrap.min.css";

class CreateSign extends Component {
  constructor() {
    super();
    this.state = {
      dataSign: "",
      dataPrivKey: "",
      dataPass: "",
      dataCert: "",

      statusCreateSignP7S: "",

      filekeyname: "файл",
      filekeyIsOpen: false,

      filedataname: "файл",
      filedataIsOpen: false,

      filecertname: "файл",
      filecertIsOpen: false,

      isValidFileSize: true,
      isValidPrivKeyFileSize: true,
      isValidCertFileSize: true,
      errors: {},
    };
    this.handleInputChangeData = this.handleInputChangeData.bind(this);
    this.handleFileDataChange = this.handleFileDataChange.bind(this);
    this.handleFileKeyChange = this.handleFileKeyChange.bind(this);
    this.handleInputChangePass = this.handleInputChangePass.bind(this);
    this.handleCertChange = this.handleCertChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleInputChangeData(e) {
    //console.log(e.target.value);
    try {
      this.setState({
        filedataname: "файл",
        filedataIsOpen: false,
        dataSign: Buffer.from(e.target.value).toString("base64"),
      });
      if (e.target.value.length === 0) {
        document.getElementById("filedata").disabled = false;
      } else {
        document.getElementById("filedata").disabled = true;

      }
      //console.log(e.target.value);
    } catch (error) {
      //console.log(error);
    }
  }

  handleFileDataChange() {
    try {
      const file = document.getElementById("filedata").files[0];
      //console.log(file);

      if (file !== undefined && file.size < 20000000) {

        document.getElementById("inputDataForSign").disabled = true;

        this.setState({ filedataname: file.name, isValidFileSize: true, filedataIsOpen: true });
        var reader = new FileReader();
        reader.readAsArrayBuffer(file);
        reader.onload = () => {
          const buffer = reader.result;

          const data = new Buffer(new Uint8Array(buffer)).toString("base64");

          this.setState({
            dataSign: data,
          });
          //console.log(data);
        };
        reader.onerror = (e) => {
          console.error(e);
        };
      } else {
        document.getElementById("inputDataForSign").disabled = false;

        this.setState({ filedataname: "файл", isValidFileSize: false, filedataIsOpen: false });
      }
    } catch (error) {
      //console.log(error);
    }
  }

  handleFileKeyChange() {
    try {
      const file = document.getElementById("filekey").files[0];
      //console.log(file);

      if (file !== undefined && file.size < 20000000) {

        this.setState({
          filekeyname: file.name, isValidPrivKeyFileSize: true,
          filekeyIsOpen: true
        });
        var reader = new FileReader();
        reader.readAsArrayBuffer(file);
        reader.onload = () => {
          const buffer = reader.result;

          const data = new Buffer(new Uint8Array(buffer)).toString("base64");

          this.setState({
            dataPrivKey: data,
          });
          //console.log(data);
        };
        reader.onerror = (e) => {
          console.error(e);
        };
      } else {
        this.setState({
          filekeyname: "файл", isValidPrivKeyFileSize: false,
          filekeyIsOpen: false
        });
      }
    } catch (error) {
      //console.log(error);
    }
  }

  handleInputChangePass(e) {
    //console.log(e.target.value);
    try {
      this.setState({
        dataPass: Buffer.from(e.target.value).toString("base64"),
      });

      //console.log(e.target.value);
    } catch (error) {
      //console.log(error);
    }
  }

  handleCertChange() {
    try {
      const file = document.getElementById("filecert").files[0];
      //console.log(file);

      if (file !== undefined && file.size < 20000000) {
        this.setState({ filecertname: file.name, isValidCertFileSize: true, filecertIsOpen: true });
        var reader = new FileReader();
        reader.readAsArrayBuffer(file);
        reader.onload = () => {
          const buffer = reader.result;

          const data = new Buffer(new Uint8Array(buffer)).toString("base64");

          this.setState({
            dataCert: data,
          });
          //console.log(data);
        };
        reader.onerror = (e) => {
          console.error(e);
        };
      } else {
        this.setState({ filecertname: "файл", isValidCertFileSize: false, filecertIsOpen: false });
      }
    } catch (error) {
      //console.log(error);
    }
  }

  handleSubmit(e) {
    e.preventDefault();
    try {
      var data = this.state.dataSign;
      var privKey = this.state.dataPrivKey;
      var password = this.state.dataPass;
      var cert = this.state.dataCert;
      //console.log(data);
      //console.log(privKey);

      //console.log(password);

      //console.log(cert);

      CreateSignP7S(data, privKey, password, cert).then((result) => {
        try {
          //console.log(result);
          if (result.status === 200) {
            FileDownload(result.data.p7s, "signp7s.pem");
            document.getElementById("view").style.borderColor = "green";
          } else {
            document.getElementById("view").style.borderColor = "red";

            this.setState({
              statusCreateSignP7S: "Ошибка",
            });
          }
        } catch (error) {
          //console.log(error);
          document.getElementById("view").style.borderColor = "red";

          this.setState({
            statusCreateSignP7S: "Ошибка",
          });
        }
      });
    } catch (error) {
      //console.log(error);
    }
  }

  componentDidMount() { }

  render() {
    return (
      <div className="">
        <h5 className="major">Создание подписи</h5>
        <Form onSubmit={this.handleSubmit} style={{ marginBottom: "0" }}>
          <div className="sm-4">
            <div className="row">
              {/* <Form.Label >или</Form.Label> */}
              <div className="col-lg">
                <Form.Group>
                  <Form.Label>Выберите файл для подписи</Form.Label>
                  <Form.File custom>
                    <Form.File.Input
                      id="filedata"
                      onChange={this.handleFileDataChange}
                      isValid={this.state.filedataIsOpen}
                      isInvalid={!this.state.isValidFileSize}

                    />
                    <Form.File.Label data-browse="Выбрать">
                      {this.state.filedataname}
                    </Form.File.Label>
                    <Form.Control.Feedback type="valid" />
                    <Form.Control.Feedback type="invalid">
                      максимальный размер файла 20мб
                    </Form.Control.Feedback>
                  </Form.File>
                </Form.Group>
              </div>
              <div className="block-and" >
                <Form.Label >или</Form.Label>

              </div>
              <div className="col-lg">
                <Form.Group>
                  <Form.Label>Введите текст для подписи</Form.Label>
                  <Form.Control
                    id="inputDataForSign"
                    type="text"
                    placeholder="Текст"
                    onChange={this.handleInputChangeData}
                    style={{ height: "2rem", color: "white" }}
                  />
                </Form.Group>
              </div>
            </div>
          </div>
          <div className="sm-4">
            <div className="row">
              <div className="col-lg">
                <Form.Group>
                  <Form.Label>Выберите личный ключ</Form.Label>
                  <Form.File custom>
                    <Form.File.Input
                      id="filekey"
                      onChange={this.handleFileKeyChange}
                      isValid={this.state.filekeyIsOpen}
                      isInvalid={!this.state.isValidPrivKeyFileSize}

                      required
                    />
                    <Form.File.Label data-browse="Выбрать">
                      {this.state.filekeyname}
                    </Form.File.Label>
                    <Form.Control.Feedback type="valid" />
                    <Form.Control.Feedback type="invalid">
                      максимальный размер файла 20мб
                    </Form.Control.Feedback>
                  </Form.File>
                </Form.Group>
              </div>
              <div className="col-lg">
                <Form.Group>
                  <Form.Label>Введите пароль личного ключа</Form.Label>
                  <Form.Control
                    type="password"
                    placeholder="Пароль"
                    onChange={this.handleInputChangePass}
                    style={{ height: "2rem", color: "white" }}
                    // required
                  />
                </Form.Group>
              </div>
            </div>
          </div>
          <div className="sm-4">
            <div className="row">
              <div className="col-lg">
                <Form.Group>
                  <Form.Label>Выберите сертификат</Form.Label>
                  <Form.File custom>
                    <Form.File.Input
                      id="filecert"
                      onChange={this.handleCertChange}
                      isValid={this.state.filecertIsOpen}
                      isInvalid={!this.state.isValidCertFileSize}

                      required
                    />
                    <Form.File.Label data-browse="Выбрать">
                      {this.state.filecertname}
                    </Form.File.Label>
                    <Form.Control.Feedback type="valid" />
                    <Form.Control.Feedback type="invalid">
                      максимальный размер файла 20мб
                    </Form.Control.Feedback>
                  </Form.File>
                </Form.Group>
              </div>
              <div className="col-lg">
                <Form.Label style={{ float: "left" }}>
                  {this.state.statusCreateSignP7S}
                </Form.Label>
                <Button
                  style={{ float: "right", marginTop: "25px" }}
                  type="submit"
                  size="sm"
                >
                  Подписать
                </Button>
              </div>
            </div>
          </div>
        </Form>
      </div>
    );
  }
}
export default connect()(withRouter(CreateSign));
